$(window).on('scroll resize', function () {
  const $steps = $('.welcome-step');
  const $fillLine = $('.steps-fill');
  const $parent = $('.wp-block-acf-onboarding');

  if ($steps.length >= 2 && $fillLine.length && $parent.length) {
    const scrollTop = $(window).scrollTop();
    const windowHeight = $(window).height();
    const screenBottom = scrollTop + windowHeight;

    const parentTop = $parent.offset().top;
    const parentHeight = $parent.outerHeight();

    // 1. Core anchors for starting and finishing the track
    const firstStepBottom = $steps.first().offset().top + $steps.first().outerHeight();
    const lastStepBottom = $steps.last().offset().top + $steps.last().outerHeight();
    const totalScrollDistance = lastStepBottom - firstStepBottom;

    // --- Part A: Handle the Sequential "is-lit" Class Rules ---
    // We process classes first so we know exactly which steps are active
    const stepStates = [];

    $steps.each(function (index) {
      const $this = $(this);
      const stepBottom = $this.offset().top + $this.outerHeight();
      let isLit = false;

      if (index === 0) {
        if (screenBottom >= stepBottom) {
          isLit = true;
        }
      } else {
        const $prevStep = $steps.eq(index - 1);
        const prevStepBottom = $prevStep.offset().top + $prevStep.outerHeight();

        // Active state triggers when preceding step is passed AND current step is fully passed
        if (screenBottom >= prevStepBottom && screenBottom >= stepBottom) {
          isLit = true;
        }
      }

      if (isLit) {
        $this.addClass('is-lit');
      } else {
        $this.removeClass('is-lit');
      }

      // Store the active state for the line height calculation
      stepStates.push(isLit);
    });

    // --- Part B: Smooth Line Height Calculation with Aligned Ceiling ---
    let targetLineHeight = 0;

    if (screenBottom >= firstStepBottom) {
      // Calculate what the fluid continuous height would normally be
      const currentScrollProgress = screenBottom - firstStepBottom;
      let scrollPercent = currentScrollProgress / totalScrollDistance;
      scrollPercent = Math.min(Math.max(scrollPercent, 0), 1);

      const continuousHeight = scrollPercent * parentHeight;

      // Enforce the hard ceiling rules based on whether the next step has activated .is-lit
      let allowedMaxHeight = parentHeight;

      $steps.each(function (index) {
        if (index === 0) return; // Skip first step

        // If this step is NOT lit yet, the line is capped exactly at its top boundary
        if (!stepStates[index]) {
          const stepTop = $(this).offset().top;
          const stepTopRelativeToParent = stepTop - parentTop;

          if (stepTopRelativeToParent < allowedMaxHeight) {
            allowedMaxHeight = stepTopRelativeToParent;
          }
        }
      });

      // Apply the restrictive cap to our smooth animation value
      targetLineHeight = Math.min(continuousHeight, allowedMaxHeight);
      $fillLine.css('height', targetLineHeight + 'px');
    } else {
      $fillLine.css('height', '0px');
    }
  }
});
